import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "../wms/input";
import FontAwesome from 'react-fontawesome';
import Permitlist from './renderpermit';

const ConfirmSubmit = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  error,size ="sl"
}) => {
  // const worklist = list.WorkerList;
  const [url, seturl] = useState("http://wms.advanceagro.net/wsface/api/face/CardImage?IdentityID=");
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader> 
        {header}
        {list && list.IdentityID && 
      
         <p className="font-weight-normal" >
          ยืนยันใบหน้า
       </p>
        }
        </ModalHeader>
        <ModalBody>

          { list && 
          <div className="container-fluid">
          <div className="row" style={{ fontSize: "14px" }}>
            <div className="col-lg-4  col-sm-6 ">
              <p className="font-weight-normal">
                ชื่อ  : {list.FnameT}
              </p>
            </div>
            <div className="col-lg-4  col-sm-6 ">
              <p className="font-weight-normal">
                บัตรประชาชน  : {list.IdentityID}
              </p>
            </div>
            </div>
            <div className="col-lg-4  col-sm-6 ">
                      <img
                        src={url+list.IdentityID + "&size=320"}
                        className="rounded-circle me-1"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                        style={{
                          maxHeight: "100px",
                          Width: "100%",
                          maxWidth: "100px",
                        }}
                      ></img>
                    </div>
            </div>
          
          }
         

          {/* {!list && message} */}
        </ModalBody>
        { error && <div className="col-md-6 alert alert-danger">  { error}</div>}

        {/* {list && list.IdentityID &&
            <Button color="danger">
              {list.IdentityID}
            </Button>
          } */}
        <ModalFooter>
          <Button color="primary"  onClick={() =>onConfirm(list.IdentityID) }>
            {button1}
          </Button>{" "}
          {/* {list && (
            <Button color="danger" onClick={onDisAprove}>
              ไม่อนุมัติ
            </Button>
          )} */}
          <Button color="secondary" onClick={onCancel}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmSubmit;
